import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModalService } from '@lsq-frontend/common-ui';

@Component({
    selector: 'mfa-backup-codes',
    styleUrls: ['./mfa-backup-codes-modal.component.scss'],
    template: `
        <div class="modal-body mfa-backup-code-modal">
            <p class=" body" [style.marginBottom]="'2rem'">
                In addition to our Multi-Factor Authentication for security, we have also generated
                these backup codes for you to sign into your account if you don't have your phone
                with you. These codes can only be used once per login. Please do not share these
                codes with anyone else.
            </p>
            <p class="label" [style.marginBottom]="'1rem'">
                Your Backup Codes ({{ codes.length }}):
            </p>
            <data-card [style.marginBottom]="'2rem'">
                <div class="p body">
                    <div class="row">
                        <div class="col">
                            <div *ngFor="let code of codes.slice(this.codes.length / 2)">
                                {{ code }}
                            </div>
                        </div>
                        <div class="col">
                            <div *ngFor="let code of codes.slice(0, this.codes.length / 2)">
                                {{ code }}
                            </div>
                        </div>
                    </div>
                </div>
            </data-card>

            <form [formGroup]="formGroup">
                <lsq-checkbox
                    id="confirm-mfa-backup-code"
                    label="I've saved the codes above and put them in a safe location."
                    [group]="formGroup"
                    formControlName="hasCopiedMfaBackupCodes"
                >
                </lsq-checkbox>
            </form>
        </div>
    `
})
export class MfaBackupCodesModalComponent {
    public codes: string[];
    public formGroup: FormGroup;

    constructor(private _modalService: ModalService) {
        this.codes = this._modalService.modal.data.codes;
        this.formGroup = this._modalService.modal.data.formGroup;
    }
}
